export default "__VITE_ASSET__Ekr0S5LV__"